import { Badge } from "@/components/ui/badge";
import {
  FUNDING_SOURCE_LABELS,
  type BillingCycleStatus,
  type FundingSource,
} from "@/types/billing-cycle";

const STATUS_COLORS: Record<string, string> = {
  Active: "bg-ok-soft text-ok-ink",
  Paused: "bg-warn-soft text-warn-ink",
  Suspended: "bg-warn-soft text-warn-ink",
  Expired: "bg-secondary text-muted-foreground",
  Cancelled: "bg-destructive-soft text-destructive-ink",
};

/** Colour for a billing-cycle status chip. Exported so the summary cards match the table. */
export function getBillingCycleStatusColor(status: string): string {
  return STATUS_COLORS[status] || "bg-secondary text-muted-foreground";
}

export function BillingCycleStatusBadge({
  status,
}: {
  status: BillingCycleStatus | string;
}) {
  return (
    <Badge
      variant="outline"
      className={`px-1.5 py-0 text-[11px] ${getBillingCycleStatusColor(status)}`}
    >
      {status}
    </Badge>
  );
}

const FUNDING_SOURCE_COLORS: Record<string, string> = {
  Payment: "bg-info-soft text-info-ink",
  SignupBonus: "bg-brand-soft text-brand-ink",
  // Neutral on purpose: nobody paid for this period — the previous owner already had — so it
  // must not read like either of the two that involved money.
  Transfer: "bg-muted text-muted-foreground",
};

/**
 * Funding source reads as "Paid" / "Trial" in the UI — that is the distinction an operator is
 * actually making — while the filter still sends the backend enum name.
 */
export function FundingSourceBadge({
  fundingSource,
}: {
  fundingSource: FundingSource | string;
}) {
  return (
    <Badge
      variant="outline"
      className={`px-1.5 py-0 text-[11px] ${
        FUNDING_SOURCE_COLORS[fundingSource] ||
        "bg-secondary text-muted-foreground"
      }`}
    >
      {FUNDING_SOURCE_LABELS[fundingSource as FundingSource] || fundingSource}
    </Badge>
  );
}
